import { StringUnion } from '../../../../typescript';
import { BaseUrl } from '../../base-urls';

export const getWordPressHeaders = (): Record<string, string> => {
    const apiKey = process.env.WORDPRESS_API_FW_SECRET;
    const userAgent = process.env.X_USER_AGENT;

    if (!apiKey) {
        throw new Error(
            'WORDPRESS_API_FW_SECRET environment variable is required. This variable must be set in a server-only environment and will not be available client-side.',
        );
    }

    if (!userAgent) {
        throw new Error(
            'X_USER_AGENT environment variable is required. This variable must be set in a server-only environment and will not be available client-side.',
        );
    }

    return {
        'User-Agent': userAgent,
        'x-wordpress-api-secret': apiKey,
    };
};

const makeWordPressApiHeaders = (baseUrl?: StringUnion<BaseUrl>): Record<string, string> => {
    if (baseUrl !== 'wordpress') return {};
    return getWordPressHeaders();
};

export { makeWordPressApiHeaders };
